"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZoomButtons = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _hooks = require("../../../../hooks");
var _models = require("../../../../models");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ZoomButtons = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    mapMethods
  } = (0, _hooks.usePickupPointsSearchConfiguration)();
  const onZoomIn = (0, _react.useCallback)(() => {
    mapMethods.current?.zoomIn();
  }, [mapMethods]);
  const onZoomOut = (0, _react.useCallback)(() => {
    mapMethods.current?.zoomOut();
  }, [mapMethods]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(_models.TestId.SelectPickupPointDialogZoomButtons),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.IconButton, {
      color: "default",
      size: "large",
      variant: "text",
      onClick: onZoomIn,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Add, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.IconButton, {
      color: "default",
      size: "large",
      variant: "text",
      onClick: onZoomOut,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Remove, {})
    })]
  });
};
exports.ZoomButtons = ZoomButtons;